import React, { Component } from 'react';
import { bool, func } from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import cn from 'classnames';
import header from './Header/Header.module.scss';
import strings from '../lang/lang';
import Routes from './Routes';
import Switcher from './Switcher';
import { logout } from './auth/redux/authActions';
import { getEnvConfig } from '../redux/env/envActions';
import { setMenuClose } from '../redux/mobileMenu/mobileMenuActions';
import { toggleSupportMessage} from '../redux/reducers/support';
import mobileMenu from './MobileMenu.module.scss';
import Button from '../elements/Button/Button';
import { NavigationMenu } from '.';

import { ReactComponent as ProfileIcon } from '../styles/icon/header/profile.svg';
import { ReactComponent as HeaderApps } from '../styles/icon/header/apps.svg';
import { ReactComponent as HeaderSupport } from '../styles/icon/header/support.svg';
import { ReactComponent as HeaderFintoIo } from '../styles/icon/header/staq-io.svg';
import { ReactComponent as Logout } from '../styles/icon/header/logoutClean.svg';
import {keycloak} from "../keycloak-config";

const mapStateToProps = (state) => {
  return {
    isProdSwitcherOpen: state.prodSwitcher.isProdSwitcherOpen,
    isSwitcherOpen: state.switcher.isSwitcherOpen,
  };
};

const mapDispatchToProps = {
  setMenuClose,
  toggleSupportMessage
};

class MobileMenu extends Component {
  static propTypes = {
    isSwitcherOpen: bool,
    toggleSupportMessage: func
  }

  constructor(props) {
    super(props);
    this.state = {
      isEnabled: 'false',
    };
  }

  componentDidMount() {
    getEnvConfig().then((result) => {
      const liveModeFeatureEnabled = result['LIVE_MODE_FEATURE_ENABLED'];
      if (liveModeFeatureEnabled) {
        this.setState({
          isEnabled: liveModeFeatureEnabled,
        });
      }
    });
  }

  myRef = React.createRef();

  async logoutAction() {
    this.props.history.push('/');
    await logout();
  }

  render() {
    const { isSwitcherOpen, location: { pathname } } = this.props;

    return (
      <div ref={this.myRef} className={cn(mobileMenu.mobile_menu, 'menu')}>
        <ul className={mobileMenu.mobile_menu__list}>
          <NavigationMenu />
          {keycloak.authenticated && (
            <>
              <li
                onClick={this.props.setMenuClose}
                className={cn({
                  [mobileMenu['mobile_menu__list--active']]: pathname.indexOf(`/apps`) !== -1
                })}
              >
                <Link className={header.header__link_docs} to={Routes.routes.APPLIST.path}>
                  <HeaderApps />
                  <p>{strings.header.text.appsLink}</p>
                </Link>
              </li>
              <li
                onClick={() => {
                  this.props.setMenuClose();
                  this.props.toggleSupportMessage({ status: false });
                }}
                className={cn({
                  [mobileMenu['mobile_menu__list--active']]: pathname.indexOf(`/support`) !== -1
                })}
              >
                <Link className={header.header__link_docs} to={Routes.routes.SUPPORT.path}>
                  <HeaderSupport />
                  <p>{strings.header.text.supportLink}</p>
                </Link>
              </li>
              <li>
                <a className={header.header__link_docs} href="https://staq.io/" target="_blank">
                  <HeaderFintoIo />
                  <p>{strings.header.text.mainPageLink}</p>
                </a>
              </li>
              <li
                onClick={this.props.setMenuClose}
                className={cn({
                  [mobileMenu['mobile_menu__list--active']]: pathname.indexOf(`/profile`) !== -1
                })}
              >
                <Link className={header.header__link_docs} to={Routes.routes.PROFILE.path}>
                  <ProfileIcon />
                  <p>{strings.header.text.profileLink}</p>
                </Link>
              </li>
              <li
                onClick={this.props.setMenuClose}
              >
                <button
                  onClick={this.logoutAction.bind(this)}
                  className={mobileMenu.mobile_menu__btn_logout}
                >
                  <Logout />
                  <p>Log out</p>
                </button>
              </li>
            </>
          )}
          <li
            className={mobileMenu.mobile_menu__switcher}
          >
            <div>
              <span>{isSwitcherOpen ? 'Dark Theme' : 'Light Theme'}</span>
              <Switcher handleDiameter={16} height={11} width={27} />
            </div>
          </li>
        </ul>
        {!keycloak.authenticated && (
          <div className={mobileMenu.mobile_menu__auth_btns}>
            <div onClick={this.props.setMenuClose}>
              <Button name={strings.header.buttons.signUp} onClick={() => keycloak.register()} variant="gradient_auth_none" />
            </div>
            <div onClick={this.props.setMenuClose}>
              <Button name={strings.header.buttons.signIn} onClick={() => keycloak.login()} variant="gradient_auth" />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MobileMenu));
